/* eslint-disable @typescript-eslint/no-require-imports */
import React from 'react';
import {
  Dimensions,
  DimensionValue,
  Image,
  ImageSourcePropType,
  Platform,
  ScrollView,
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';
import Label from '../Label';
import {PageContainer} from '../PageContainer';

interface DetailAssuranceContainerProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}
export const DetailAssuranceContainer = ({
  children,
  style,
}: DetailAssuranceContainerProps) => {
  return Platform.OS === 'web' ? (
    <PageContainer>
      <Label
        style={[{paddingHorizontal: 20}]}
        textStyle={{textTransform: 'uppercase'}}
        title="Assurance obsèques à dago"
        type="mainTitle"
      />
      {children}
    </PageContainer>
  ) : (
    <>
      <Label
        style={{paddingHorizontal: 20}}
        textStyle={{textTransform: 'uppercase'}}
        title="Assurance obsèques à dago"
        type="mainTitle"
      />
      <ScrollView style={[{paddingHorizontal: 10}, style]}>
        {children}
      </ScrollView>
    </>
  );
};

interface ButtonItemsProps {
  image: ImageSourcePropType;
  action: () => void;
  libelle: string;
  style?: StyleProp<ViewStyle>;
}
export const ButtonItems = ({
  image,
  action,
  libelle,
  style,
}: ButtonItemsProps) => (
  <TouchableOpacity
    style={[styles.containerMenuItem, {alignItems: 'center'}, style]}
    onPress={action}>
    <Image style={{width: 30, height: 30}} source={image} />
    <Label
      textStyle={{textAlign: 'center', marginTop: 20, fontSize: 13}}
      title={libelle}
    />
    <View children />
  </TouchableOpacity>
);

interface BoxShadowedProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}
export const BoxShadowed = ({children, style}: BoxShadowedProps) => {
  return <View style={[styles.BoxShadowedContainer, style]}>{children}</View>;
};

interface DetailAssuranceContainerProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
}
export const Container = ({children, style}: DetailAssuranceContainerProps) => {
  return Platform.OS === 'web' ? (
    <PageContainer>{children}</PageContainer>
  ) : (
    <View style={style}>{children}</View>
  );
};

const windowDim = Dimensions.get('window').width;
const styles = StyleSheet.create({
  BoxShadowedContainer:
    Platform.OS === 'web'
      ? {
          margin: 12,
          padding: windowDim <= 400 ? 12 : 24,
          minWidth:
            windowDim <= 400
              ? ('calc(100% - 24px)' as DimensionValue)
              : ('calc(25% - 24px)' as DimensionValue),
          backgroundColor: 'white',
          borderRadius: 16,
          justifyContent: 'flex-start',
          shadowOffset: {width: 2, height: 6},
          shadowColor: '#000000',
          shadowOpacity: 0.1,
          shadowRadius: 16,
          elevation: 4,
        }
      : {
          backgroundColor: '#fff',
          ...Platform.select({
            ios: {
              shadowOffset: {width: 0, height: 2},
              shadowRadius: 4,
            },
            android: {
              elevation: 4,
            },
            web: {
              elevation: 4,
            },
          }),
          shadowColor: 'gray',
          shadowOpacity: 0.2,
          borderRadius: 20,
          paddingHorizontal: 10,
          paddingVertical: 20,
          margin: 10,
        },
  containerMenuItem:
    Platform.OS === 'web'
      ? {
          height: 156,
          margin: 12,
          padding: windowDim <= 400 ? 12 : 24,
          flexBasis:
            windowDim <= 725
              ? ('calc(50% - 24px)' as DimensionValue)
              : ('calc(25% - 24px)' as DimensionValue),
          minWidth:
            windowDim <= 400
              ? ('calc(100% - 24px)' as DimensionValue)
              : ('calc(25% - 24px)' as DimensionValue),
          backgroundColor: 'white',
          borderRadius: 16,
          alignItems: 'center',
          justifyContent: 'flex-start',
          flex: 1,
          shadowOffset: {width: 2, height: 6},
          shadowColor: '#000000',
          shadowOpacity: 0.1,
          shadowRadius: 16,
          elevation: 4,
        }
      : {
          margin: 10,
          flexDirection: 'column',
          width: '25%',
          alignItems: 'center',
          backgroundColor: 'white',
          paddingVertical: 20,
          paddingHorizontal: 10,
          marginLeft: 10,
          marginTop: 10,
          marginRight: 10,
          borderRadius: 20,
          elevation: 4,
          shadowOffset: {width: 2, height: 6},
          shadowColor: '#000000',
          shadowOpacity: 0.1,
          shadowRadius: 16,
        },
});
